import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';
import {
  FormItem,
  FormField,
  FormLabel,
  FormControl,
  FormMessage,
  useFormField,
  FormDescription,
} from '../Form';

import { Input } from '../Input';
import { Button } from '../Button';
import { cn } from '@/utils/styles';

export interface PasswordFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: React.ReactNode;
  description?: React.ReactNode;
  hideFormMessage?: boolean;
  eyeIconColor?: string;
}

export const PasswordField = ({
  name,
  label,
  className,
  description,
  placeholder,
  hideFormMessage = false,
  eyeIconColor,
  ...rest
}: PasswordFieldProps) => {
  const formField = useFormField();
  const [showPassword, setShowPassword] = useState(false);

  const fieldType = showPassword ? 'text' : 'password';
  const FieldIcon = showPassword ? Eye : EyeOff;

  const toggleFieldType = () => {
    setShowPassword(!showPassword);
  };

  return (
    <FormField
      name={name}
      control={formField.control}
      render={({ field }) => (
        <FormItem className={className}>
          <FormControl>
            <Input
              type={fieldType}
              {...rest}
              onChange={field.onChange}
              placeholder={placeholder}
              value={field.value}
              className={cn('pr-11', label && 'pt-6 h-14 pb-1')}
            >
              {label && (
                <FormLabel className="absolute top-2 typography-btn-small">
                  {label}
                </FormLabel>
              )}

              <Button
                size="icon"
                type="button"
                variant="tertiary"
                onClick={toggleFieldType}
                className="h-auto absolute right-2 top-0 bottom-0 hover:bg-transparent active:bg-transparent active:outline-none"
              >
                {<FieldIcon size={24} color={eyeIconColor} />}
              </Button>
            </Input>
          </FormControl>

          {description && <FormDescription>{description}</FormDescription>}

          {!hideFormMessage && <FormMessage />}
        </FormItem>
      )}
    />
  );
};
